import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getDatabase } from "firebase/database";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

// ✅ Firebase Config from .env
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);

// ✅ Initialize Analytics safely
let analytics: ReturnType<typeof getAnalytics> | null = null;
isSupported().then((supported) => {
  if (supported) analytics = getAnalytics(app);
});

// ✅ Initialize Compat App (needed for GeoFirestore)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}



// ✅ Initialize Auth & Set Local Persistence
const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(console.error);

// ✅ Export the compat version for GeoFirestore
export { firebase };

// ✅ Export Firebase Services
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const rtdb = getDatabase(app, "https://eartlas-default-rtdb.europe-west1.firebasedatabase.app");
export { auth };
export const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY!;